import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';

import { AiOutlineSearch } from "react-icons/ai";
import Spinner from '../../../../../components/Spinner'
import { Header, TableWrapper, TableSection, SearchWrapper } from '../../DashBoard/dashBoardStyled'
//table
import { Table } from 'reactstrap';
import CsvDownloader from 'react-csv-downloader';
import { MdKeyboardBackspace } from "react-icons/md";
import Pagination from '@material-ui/lab/Pagination';

function ClaimReport() {
    let history = useHistory();
    let location = useLocation();
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [dataList, setDataList] = useState([]);
    const [finalData, setFinalData] = useState([])
    const [csvData, setCsvData] = useState([])
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [tableSearch, setTableSearch] = useState('')

    useEffect(() => {
        if (location.state !== null && location.state !== undefined) {
            let tempData = []
            let initialData = location.state.data

            if (location.state.claimType === 'All') tempData = initialData
            if (location.state.claimType === 'Pending Claim') tempData = initialData.filter(data => data.claimStatus === 'PENDING')
            if (location.state.claimType === 'Resolved Claim') tempData = initialData.filter(data => data.claimStatus === 'RESOLVED')
            if (location.state.claimType === 'Escalated Claim') tempData = initialData.filter(data => data.claimStatus === 'REJECTED')

            let tempDataSorted = tempData.sort((a, b) => b.created - a.created)

            //set csv data
            csvfunction(tempDataSorted)
            // let tempCsvData = tempDataSorted.map(val => {
            //     return ({
            //         OrderId: val.orderId,
            //         PostName: val.postTitle?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         AddressType: val.addressType === "PICKUP" ? 'PickUp' : 'Delivery',
            //         ClaimRaisedDate: val.claimDateBuyerSide ? moment(val.claimDateBuyerSide).format("MM-DD-YYYY") : 'NA',
            //         ClaimResolvedDate: val.claimDateSellerSide ? moment(val.claimDateSellerSide).format("MM-DD-YYYY") : 'NA',
            //         ClaimRaised: val.claimRaisedCompanyName,
            //         ClaimRaisedCity: val.shipTo?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         ClaimRaisedState: val.shipTo?.state,
            //         ClaimRaisedZip: val.shipTo?.zip,
            //         ClaimRaisedBroker: val.buyerIsReseller ? 'Yes' : 'No',
            //         // ClaimRaisedFCMember: val.buyerInnerCircle ? 'Yes' : 'No',
            //         ClaimReceived: val.claimReceivedCompanyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         ClaimReceivedCity: val.shipFrom?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         ClaimReceivedState: val.shipFrom?.state,
            //         ClaimReceivedZip: val.shipFrom?.zip,
            //         ClaimReceivedBroker: val.sellerIsReseller ? 'Yes' : 'No',
            //         ClaimReceivedFCMember: val.sellerInnerCircle ? 'Yes' : 'No',
            //         ClaimResolutionMethod: val.claimStatus === 'REJECTED' ? 'Escalated' :
            //             val.claimStatus === 'PENDING' ? 'Pending' :
            //                 (val.claimStatus === 'RESOLVED' && val.issueType === "BOL") ? 'Seller-Resolved' :
            //                     val.adminResolutionClaimDetails ? `PT Admin-${val.adminResolutionClaimDetails?.action}` :
            //                         val.resolutionMessage ? `Seller-${val.resolutionMessage}` :
            //                             val.sellerComment ? `Seller${val.sellerComment}` : '',
            //         Commodity: val.commodity?.commodityName ? val.commodity.commodityName : 'Custom',
            //         Quantity: val.quantity,
            //         IssueType: val.issueType,
            //         TotalPrice: val.issueType === 'BOL' ? `$${(val.pricePerPallet * val.quantity)?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : (val.claimTotalPrice && `$${val.claimTotalPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`),
            //         Comments: val.comments?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         ClaimStatus: val.claimStatus
            //     })
            // })
            // setCsvData(tempCsvData)

            if (tempDataSorted !== null) setDataList(tempDataSorted)
            //pagination
            let pageData = JSON.parse(JSON.stringify(tempDataSorted))
            setFinalData(pageData.splice(page * 10 - 10, 10))
            if (tempDataSorted.length % 10 === 0) {
                setPageCount(tempDataSorted.length / 10)
            } else {
                setPageCount(Math.trunc(tempDataSorted.length / 10) + 1)
            }
        } else {
            history.push({
                pathname: '/reports',
                state: { page: 'claim' }
            })
        }
    }, []);

    const csvfunction = (getData)=>{
        let tempCsvData = getData.map(val => {
            return ({
                OrderId: val.orderId,
                PostName: val.postTitle?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                AddressType: val.addressType === "PICKUP" ? 'PickUp' : 'Delivery',
                ClaimRaisedDate: val.claimDateBuyerSide ? moment(val.claimDateBuyerSide).format("MM-DD-YYYY") : 'NA',
                ClaimResolvedDate: val.claimDateSellerSide ? moment(val.claimDateSellerSide).format("MM-DD-YYYY") : 'NA',
                ClaimRaised: val.claimRaisedCompanyName,
                ClaimRaisedCity: val.shipTo?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                ClaimRaisedState: val.shipTo?.state,
                ClaimRaisedZip: val.shipTo?.zip,
                ClaimRaisedBroker: val.buyerIsReseller ? 'Yes' : 'No',
                // ClaimRaisedFCMember: val.buyerInnerCircle ? 'Yes' : 'No',
                ClaimReceived: val.claimReceivedCompanyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                ClaimReceivedCity: val.shipFrom?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                ClaimReceivedState: val.shipFrom?.state,
                ClaimReceivedZip: val.shipFrom?.zip,
                ClaimReceivedBroker: val.sellerIsReseller ? 'Yes' : 'No',
                ClaimReceivedFCMember: val.sellerInnerCircle ? 'Yes' : 'No',
                ClaimResolutionMethod: val.claimStatus === 'REJECTED' ? 'Escalated' :
                    val.claimStatus === 'PENDING' ? 'Pending' :
                        (val.claimStatus === 'RESOLVED' && val.issueType === "BOL") ? 'Seller-Resolved' :
                            val.adminResolutionClaimDetails ? `PT Admin-${val.adminResolutionClaimDetails?.action}` :
                                val.resolutionMessage ? `Seller-${val.resolutionMessage}` :
                                    val.sellerComment ? `Seller${val.sellerComment}` : '',
                Commodity: val.commodity?.commodityName ? val.commodity.commodityName : 'Custom',
                Quantity: val.quantity,
                IssueType: val.issueType,
                TotalPrice: val.issueType === 'BOL' ? `$${(val.pricePerPallet * val.quantity)?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}` : (val.claimTotalPrice && `$${val.claimTotalPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "")}`),
                Comments: val.comments?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                ClaimStatus: val.claimStatus
            })
        })
        setCsvData(tempCsvData)

    }

    const handleChange = (event, value) => {
        setPage(value);
        const search = tableSearch
        let dataListtemp = dataList.filter(value => {
            return (
                (value.orderId && value.orderId.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.postTitle && value.postTitle.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.claimRaisedCompanyName && value.claimRaisedCompanyName.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.claimReceivedCompanyName && value.claimReceivedCompanyName.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.quantity && value.quantity.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.issueType && value.issueType.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.claimTotalPrice && value.claimTotalPrice.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.comments && value.comments.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.claimStatus && value.claimStatus.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.commodity !== null && value.commodity.commodityName && value.commodity.commodityName.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipFrom !== null && value.shipFrom.city && value.shipFrom.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipFrom !== null && value.shipFrom.state !== null && value.shipFrom.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipFrom !== null && value.shipFrom.zip !== null && value.shipFrom.zip.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipTo !== null && value.shipTo.city !== null && value.shipTo.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipTo !== null && value.shipTo.state !== null && value.shipTo.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipTo !== null && value.shipTo.zip !== null && value.shipTo.zip.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    let headerArr = [
        { title: 'Order Id', },
        { title: 'Post Name', },
        { title: 'Type', },
        { title: 'Claim Raised Date', },
        { title: 'Claim Resolved Date', },
        { title: 'Claim Raised Company', },
        { title: 'Claim Raised Company City', },
        { title: 'Claim Raised Company State', },
        { title: 'Claim Raised Company Zip', },
        { title: 'Claim Raised Company Broker', },
        // { title: 'Claim Raised Company FC Member', },
        { title: 'Claim Received Company', },
        { title: 'Claim Received Company City', },
        { title: 'Claim Received Company State', },
        { title: 'Claim Received Company Zip', },
        { title: 'Claim Received Company Broker', },
        { title: 'Claim Received Company FC Member', },
        { title: 'Resolution Details', },
        { title: 'Commodity', },
        { title: 'Quantity', },
        { title: 'Issue Type', },
        { title: 'Total Price', },
        { title: 'Comments', },
        { title: 'Claim Status', }
    ];

    //for csv download
    const columns = [
        { id: 'OrderId', displayName: 'Order Id' },
        { id: 'PostName', displayName: 'Post Name' },
        { id: 'AddressType', displayName: 'Type' },
        { id: 'ClaimRaisedDate', displayName: 'Claim Raised Date' },
        { id: 'ClaimResolvedDate', displayName: 'Claim Resolved Date' },
        { id: 'ClaimRaised', displayName: 'Claim Raised Company' },
        { id: 'ClaimRaisedCity', displayName: 'Claim Raised Company City' },
        { id: 'ClaimRaisedState', displayName: 'Claim Raised Company State' },
        { id: 'ClaimRaisedZip', displayName: 'Claim Raised Company Zip' },
        { id: 'ClaimRaisedBroker', displayName: 'Claim Raised Company Broker' },
        // { id: 'ClaimRaisedFCMember', displayName: 'Claim Raised Company FC Member' },
        { id: 'ClaimReceived', displayName: 'Claim Received Company' },
        { id: 'ClaimReceivedCity', displayName: 'Claim Received Company City' },
        { id: 'ClaimReceivedState', displayName: 'Claim Received Company State' },
        { id: 'ClaimReceivedZip', displayName: 'Claim Received Company Zip' },
        { id: 'ClaimReceivedBroker', displayName: 'Claim Received Company Broker' },
        { id: 'ClaimReceivedFCMember', displayName: 'Claim Received Company FC Member' },
        { id: 'ClaimResolutionMethod', displayName: 'Resolution Details' },
        { id: 'Commodity', displayName: 'Commodity' },
        { id: 'Quantity', displayName: 'Quantity' },
        { id: 'IssueType', displayName: 'Issue Type' },
        { id: 'TotalPrice', displayName: 'Total Price' },
        { id: 'Comments', displayName: 'Comments' },
        { id: 'ClaimStatus', displayName: 'Claim Status' }
    ]

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            return (
                (value.orderId && value.orderId.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.postTitle && value.postTitle.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.claimRaisedCompanyName && value.claimRaisedCompanyName.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.claimReceivedCompanyName && value.claimReceivedCompanyName.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.quantity && value.quantity.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.issueType && value.issueType.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.claimTotalPrice && value.claimTotalPrice.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.comments && value.comments.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.claimStatus && value.claimStatus.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.commodity !== null && value.commodity.commodityName && value.commodity.commodityName.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipFrom !== null && value.shipFrom.city && value.shipFrom.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipFrom !== null && value.shipFrom.state !== null && value.shipFrom.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipFrom !== null && value.shipFrom.zip !== null && value.shipFrom.zip.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipTo !== null && value.shipTo.city !== null && value.shipTo.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipTo !== null && value.shipTo.state !== null && value.shipTo.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipTo !== null && value.shipTo.zip !== null && value.shipTo.zip.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setPage(1)
        csvfunction(dataListtemp)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        setFinalData(dataListtemp.splice(0, 10))
    }

    return (
        <TableWrapper>
            {loaderVisible && <Spinner />}
            <MdKeyboardBackspace style={{ width: '28px', height: '28px', position: 'relative', left: '12px', top: '8px', cursor: 'pointer' }}
                onClick={() => {
                    history.push({
                        pathname: '/reports',
                        state: { page: 'claim' }
                    })
                }} />
            <Header>
                <h3>Claim Report</h3>
                <div className='header-search-wrapper-reports'>
                    <SearchWrapper>
                        <input style={{ border: '1px solid #87CDF1', borderRadius: '5px' }} type="text" placeholder='Search' value={tableSearch}
                            onChange={handleSearchChange} />
                        <AiOutlineSearch />
                    </SearchWrapper>
                    <CsvDownloader
                        filename="Claim Report"
                        columns={columns}
                        datas={csvData}>
                        <button
                            style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                            Export
                        </button>
                    </CsvDownloader>
                </div>
            </Header>
            <TableSection>
                <Table responsive>
                    <thead>
                        <tr>
                            {headerArr.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            finalData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.orderId}</td>
                                    <td title={items.postTitle} style={{ minWidth: '175px', whiteSpace: 'nowrap' }}>
                                        {items.postTitle?.substring(0, 25)}
                                        {items.postTitle?.length > 25 && <span>...</span>}</td>
                                    <td>{items.addressType === "PICKUP" ? 'PickUp' : 'Delivery'}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{items.claimDateBuyerSide ? moment(items.claimDateBuyerSide).format("MM-DD-YYYY") : 'NA'}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{items.claimDateSellerSide ? moment(items.claimDateSellerSide).format("MM-DD-YYYY") : 'NA'}</td>
                                    <td>{items.claimRaisedCompanyName}</td>
                                    <td>{items.shipTo?.city}</td>
                                    <td>{items.shipTo?.state}</td>
                                    <td>{items.shipTo?.zip}</td>
                                    <td>{items.buyerIsReseller ? 'Yes' : 'No'}</td>
                                    {/* <td>{items.buyerInnerCircle ? 'Yes' : 'No'}</td> */}
                                    <td>{items.claimReceivedCompanyName}</td>
                                    <td>{items.shipFrom?.city}</td>
                                    <td>{items.shipFrom?.state}</td>
                                    <td>{items.shipFrom?.zip}</td>
                                    <td>{items.sellerIsReseller ? 'Yes' : 'No'}</td>
                                    <td>{items.sellerInnerCircle ? 'Yes' : 'No'}</td>
                                    <td title={items.adminResolutionClaimDetails ? `PT Admin-${items.adminResolutionClaimDetails?.action}` :
                                        items.resolutionMessage ? `Seller-${items.resolutionMessage}` :
                                            items.sellerComment ? `Seller-${items.sellerComment}` : ''}
                                        style={{ minWidth: '175px', whiteSpace: 'nowrap' }}>
                                        {items.claimStatus === 'REJECTED' ? 'Escalated' :
                                            items.claimStatus === 'PENDING' ? 'Pending' :
                                                (items.claimStatus === 'RESOLVED' && items.issueType === "BOL") ? 'Seller-Resolved' :
                                                    items.adminResolutionClaimDetails ? `PT Admin-${items.adminResolutionClaimDetails?.action?.substring(0, 18)}` :
                                                        items.resolutionMessage ? `Seller-${items.resolutionMessage?.substring(0, 18)}` :
                                                            items.sellerComment ? `Seller-${items.sellerComment?.substring(0, 18)}` : ''}
                                        {items.adminResolutionClaimDetails ? items.adminResolutionClaimDetails?.action?.length > 18 && <span>...</span> :
                                            items.resolutionMessage?.length > 18 ? <span>...</span> :
                                                items.sellerComment?.length > 18 && <span>...</span>}
                                    </td>
                                    <td>{items.commodity?.commodityName ? items.commodity.commodityName : 'Custom'}</td>
                                    <td>{items.quantity}</td>
                                    <td>{items.issueType}</td>
                                    <td>{items.issueType === 'BOL' ? `$${(items.pricePerPallet * items.quantity)?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : (items.claimTotalPrice && `$${items.claimTotalPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`)}</td>
                                    <td title={items.comments} style={{ minWidth: '175px', whiteSpace: 'nowrap' }}>
                                        {items.comments?.substring(0, 25)}
                                        {items.comments?.length > 25 && <span>...</span>}
                                    </td>
                                    <td>{items.claimStatus}</td>
                                </tr>
                            ))}
                        {finalData.length === 0 &&
                            <p style={{ position: 'absolute', width: '100%', textAlign: 'center', marginTop: '30px' }}>No records found</p>
                        }
                    </tbody>
                </Table>
            </TableSection>
            {dataList.length !== 0 && <Pagination count={pageCount}
                page={page}
                onChange={handleChange} />}

        </TableWrapper>

    )
};

export default ClaimReport;
